import React from 'react';
import {
  Image,
  View,
  StyleSheet,
  Document,
  Text,
  Page,
  PDFViewer,
  Font,
} from '@react-pdf/renderer';
import { CoverPage, MainHeader } from './CoverPage';
import { primaryColorDark } from './PDFStyles';
import black from './Fonts/RedHatDisplay-Black.ttf';
import bold from './Fonts/RedHatDisplay-Bold.ttf';
import medium from './Fonts/RedHatDisplay-Medium.ttf';
import regular from './Fonts/RedHatDisplay-Regular.ttf';
import { CenterpieceGreenLogoPDFSvg } from '@centerpiece/components';
import { Project, Quote } from 'store/api/models.js';
import { VendorTablePDF } from './VendorTable';
import { VendorMap } from 'contexts/purchase_order.context';

const styles = StyleSheet.create({
  pageNumber: {
    position: 'absolute',
    fontSize: 14,
    bottom: 10,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: primaryColorDark,
    fontWeight: 700,
  },
  page: {
    paddingTop: 60,
    paddingBottom: 55,
  },
  subHeader: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
  },
  image: {
    width: '33%',
    paddingTop: 15,
    paddingLeft: 10,
  },
  icon: {
    width: '17px',
    height: '17px',
  },
  iconRowView: {
    position: 'absolute',
    bottom: 20,
    left: 0,
    right: 0,
    height: '30px',
  },
  iconRow: {
    display: 'flex',
    flexDirection: 'row',
    marginLeft: 18,
  },
  iconText: {
    color: primaryColorDark,
    fontWeight: 400,
    fontSize: 11,
    paddingLeft: 5,
    paddingTop: 3,
  },
});

export const QuotePDFViewer = ({ children }: { children: any }) => (
  <div style={{ width: '90%', height: '1000px' }}>
    <PDFViewer
      style={{ position: 'absolute' }}
      width={'90%'}
      height={'85%'}
      children={children}
    />
  </div>
);

export const QuotePDFDocument = ({
  vendorMap,
  project,
}: {
  project: Project;
  vendorMap: VendorMap;
}) => (
  <Document>
    <Page style={styles.page} wrap>
      <MainHeader debug={false} />
      <CoverPage project={project} />
      <VendorTablePDF vendorMap={vendorMap} />
      <Text
        style={styles.pageNumber}
        render={({ pageNumber }) => `${pageNumber}`}
        fixed
      />
    </Page>
  </Document>
);

const IconFooter = ({ debug }: { debug: boolean }) => (
  <View style={styles.iconRow} debug={debug}>
    <View style={{ flexDirection: 'row', flexBasis: '18%' }} debug={debug}>
      <Text style={styles.iconText} debug={debug}>
        888-777-2199
      </Text>
    </View>
    <View style={{ flexDirection: 'row', flexBasis: '25%' }} debug={debug}>
      <Text style={styles.iconText} debug={debug}>
        caring@homethrive.com
      </Text>
    </View>
    <View
      style={{ paddingLeft: 10, flexDirection: 'row', flexBasis: '25%' }}
      debug={debug}
    >
      <Text style={styles.iconText} debug={debug}>
        www.homethrive.com
      </Text>
    </View>
    <View style={{ flexDirection: 'row', flexBasis: '25%' }} debug={debug}>
      <Text
        style={{
          fontSize: 11,
          paddingLeft: 5,
          color: primaryColorDark,
          fontWeight: 400,
          fontFamily: 'Red Hat Display',
        }}
        debug={debug}
      >
        40 Skokie Blvd., Suite 220 Northbrook, IL 60062
      </Text>
    </View>
  </View>
);

// some ttf fonts: https://gist.github.com/sadikay/d5457c52e7fb2347077f5b0fe5ba9300
// only ttf supported at time of writing
Font.register({
  family: 'Red Hat Display',
  fonts: [
    {
      src: black,
      fontStyle: 'normal',
      fontWeight: 900,
    },
    {
      fontStyle: 'normal',
      fontWeight: 700,
      src: bold,
    },
    {
      src: medium,
      fontWeight: 500,
      fontStyle: 'normal',
    },
    {
      fontStyle: 'normal',
      fontWeight: 400,
      src: regular,
    },
  ],
});
